var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "date-of-birth" }, [
    _c("label", [_vm._v("Date of " + _vm._s(_vm.type) + "*")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "date-of-birth-row" },
      [
        _c("Input", {
          ref: "day",
          attrs: {
            name: `dayOf${_vm.type}`,
            placeholder: "DD",
            label: `Day Of ${_vm.type}`,
            required: true,
            options: _vm.days,
            startingValue: _vm.getStartingValue("day"),
            customValidation: _vm.customValidationFunction,
            vuexPath: _vm.vuexPath,
          },
        }),
        _vm._v(" "),
        _c("Input", {
          ref: "month",
          attrs: {
            name: `monthOf${_vm.type}`,
            placeholder: "MM",
            label: `Month Of ${_vm.type}`,
            required: true,
            options: _vm.monthOptions,
            optionValueKey: "value",
            optionLabelKey: "label",
            startingValue: _vm.getStartingValue("month"),
            customValidation: _vm.customValidationFunction,
            vuexPath: _vm.vuexPath,
          },
        }),
        _vm._v(" "),
        _c("Input", {
          ref: "year",
          attrs: {
            name: `yearOf${_vm.type}`,
            placeholder: "YY",
            label: `Year Of ${_vm.type}`,
            required: true,
            options: _vm.years,
            startingValue: _vm.getStartingValue("year"),
            customValidation: _vm.customValidationFunction,
            vuexPath: _vm.vuexPath,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showError
      ? _c("span", { staticClass: "date-of-birth-field-error field-error" }, [
          _vm.validateAge
            ? _c("span", {
                domProps: { innerHTML: _vm._s(_vm.validationMessage) },
              })
            : _c("span", [_vm._v("Please enter a valid date")]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }